import { anyOf, objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

const isIntegration = objectOf({
  app_group_id: string,
  company_id: string,
  integration_id: string,
  api_key: string,
  site: string,
  connected_at: string,
});

export const isGetAlloysPartnersDatadogAppGroupIdResult = objectOf({
  integration: anyOf(isIntegration, objectOf({})),
});
